var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423.8 298.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.94,96.27a42.94,42.94,0,1,0,42.94,42.94A43,43,0,0,0,42.94,96.27Zm0,59.87a16.94,16.94,0,1,1,16.94-16.93A17,17,0,0,1,42.94,156.14Z",
    fill: "#2287d5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.14,182.14A42.94,42.94,0,1,0,99.2,139.21,43,43,0,0,0,142.14,182.14Zm0-59.87a16.94,16.94,0,1,1-16.94,16.94A17,17,0,0,1,142.14,122.27Z",
    fill: "#2287d5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.27,255.79c0-26.63-22.21-43.12-43.11-42.94a42.94,42.94,0,0,0,0,85.87h.17A43,43,0,0,0,185.27,255.79Zm-59.88,0a17,17,0,0,1,16.77-16.93c7.9-.14,17.11,6.54,17.11,16.93a17,17,0,0,1-16.94,16.93h-.17A17,17,0,0,1,125.39,255.79Z",
    fill: "#2287d5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.35,182.14a42.94,42.94,0,1,0-42.94-42.93A43,43,0,0,0,241.35,182.14Zm0-59.87a16.94,16.94,0,1,1-16.94,16.94A17,17,0,0,1,241.35,122.27Z",
    fill: "#2287d5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.79,64.1a12.91,12.91,0,0,0,18.38,0L42.94,52.34,54.7,64.1c5.47,5.48,14,4.35,18.39,0a13,13,0,0,0,0-18.38L61.32,34,73.09,22.19A13,13,0,0,0,54.7,3.81L42.94,15.57,31.17,3.81A13,13,0,0,0,12.79,22.19L24.55,34,12.79,45.72A13,13,0,0,0,12.79,64.1Z",
    fill: "#2287d5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112,64.1a12.9,12.9,0,0,0,18.39,0l11.76-11.76L153.91,64.1a13,13,0,0,0,18.38-18.38L160.53,34l11.76-11.77A13,13,0,0,0,153.91,3.81L142.14,15.57,130.38,3.81A13,13,0,0,0,112,22.19L123.76,34,112,45.72A13,13,0,0,0,112,64.1Z",
    fill: "#2287d5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.2,64.1a12.89,12.89,0,0,0,18.38,0l11.77-11.76L253.11,64.1a13,13,0,0,0,18.38-18.38L259.73,34l11.76-11.77A13,13,0,0,0,253.11,3.81L241.35,15.57,229.58,3.81A13,13,0,1,0,211.2,22.19L223,34,211.2,45.72A13,13,0,0,0,211.2,64.1Z",
    fill: "#2287d5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M421.52,104.51l-48.39-53a7.62,7.62,0,0,0-11.08,0l-48.69,53.38c-5.62,6.16.86,12.55,5.54,12.55h23.77c-3,28.9-14.05,61-43.06,81.84-22.93,16.58-57.19,23.63-79.21,25.32-.41,0-11.27-.34-11,8.08v45.14a7.44,7.44,0,0,0,8.29,7.77h0q4.48-.45,9-1c52.71-6.78,103.45-27.74,134.55-70.93C381.7,185.32,391,145.19,392,117.4h24.33C423.47,117.4,426.11,108.94,421.52,104.51Z",
    fill: "#2287d5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXo);
export default __webpack_public_path__ + "static/media/xo.650427db76c5f0a83033703b09a2792a.svg";
export { ForwardRef as ReactComponent };